import { render, staticRenderFns } from "./rateTable.vue?vue&type=template&id=f90c9540&scoped=true"
import script from "./rateTable.vue?vue&type=script&lang=js"
export * from "./rateTable.vue?vue&type=script&lang=js"
import style0 from "./rateTable.vue?vue&type=style&index=0&id=f90c9540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90c9540",
  null
  
)

export default component.exports